import { TransferJobTaskStatus } from '@frameio/graphql-client/client-schema/transfers/state/transferJobTaskStatus';
import type { useAssetTransferState } from '../../shared';
import type { AssetState } from '../types';

export function getStateForTransfers(
  transferState: ReturnType<typeof useAssetTransferState>
): AssetState {
  if (!transferState) {
    return 'complete';
  }

  const { isEncoding, isPaused, status } = transferState;

  switch (status) {
    case TransferJobTaskStatus.IDLE:
    case TransferJobTaskStatus.TASK_CREATED:
      return isPaused ? 'paused' : 'queued';
    case TransferJobTaskStatus.UPLOADING:
      if (isEncoding) return 'encoding';
      return isPaused ? 'paused' : 'uploading';
    case TransferJobTaskStatus.DOWNLOADING:
      return isPaused ? 'paused' : 'uploading';
    case TransferJobTaskStatus.TRANSFER_PARTS_COMPLETE:
    case TransferJobTaskStatus.CHECKSUM_COMPLETE:
      return 'generating-thumbnail';
    case TransferJobTaskStatus.CANPREVIEW:
      return 'preparing';
    case TransferJobTaskStatus.CANVIEW:
    case TransferJobTaskStatus.TRANSCODE_COMPLETE:
      return 'complete';
    case TransferJobTaskStatus.CANCELED:
    case TransferJobTaskStatus.FAILED:
    case TransferJobTaskStatus.DEACTIVATED:
      return 'error';
    case TransferJobTaskStatus.REMOTE_ORIGIN:
      return 'remote';
    case TransferJobTaskStatus.DEVICE_UPLOADING:
      return 'external';
    default:
      return 'complete';
  }
}
